export default class Counters {
  static readonly EMPTY = new Counters();

  assignedDossiers = 0;
  vehiclesExpected = 0;
  memos = 0;
  hasMemoAlert = false;
}